/* sections.main-login scripts */
document.addEventListener('DOMContentLoaded', function () {
    const recoverForm = document.getElementById('recover');
    const loginForm = document.getElementById('login__form');
    const recoverLink = document.querySelector('a[href="#recover"]');
    const cancelLink = document.querySelector('a[href="#login"]');

    function showLoginForm() {
      if (recoverForm && loginForm) {
        recoverForm.style.display = 'none';
        loginForm.style.display = 'block';
      }
    }

    function showRecoverForm() {
      if (recoverForm && loginForm) {
        recoverForm.style.display = 'block';
        loginForm.style.display = 'none';
      }
    }

    // Handle forgot password link click
    if (recoverLink) {
      recoverLink.addEventListener('click', function (e) {
        e.preventDefault();
        showRecoverForm();
        window.location.hash = 'recover';
      });
    }

    // Handle cancel link click
    if (cancelLink) {
      cancelLink.addEventListener('click', function (e) {
        e.preventDefault();
        showLoginForm();
        window.location.hash = 'login';
      });
    }

    // Check URL hash on page load
    if (window.location.hash === '#recover') {
      showRecoverForm();
    } else {
      showLoginForm();
    }

    // Listen for hash changes (browser back/forward)
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#recover') {
        showRecoverForm();
      } else {
        showLoginForm();
      }
    });
  });
